import {
  faCog,
  faHouseChimney,
  faFilePen,
  faDrawSquare,
  faFileLines,
  faSquareInfo,
  faPaintbrushPencil,
  faMagicWandSparkles,
  faBell,
  faStore,
  faImage,
  faWandMagicSparkles,
  faCamera,
  faDroplet,
} from "@fortawesome/pro-light-svg-icons";
import { paths } from "~/router/paths";
import { INavItem } from "~/types/routing";
import { DISABLE_PAYMENTS } from "~/helpers/plans";
import { useGetUnreadNotifications } from "~/api/notifications/queries";
import {
  triggerShowConnectStoreModal,
  triggerShowNotifications,
} from "~/helpers/customEvents";
import { faPencil } from "@fortawesome/pro-regular-svg-icons";

const currentVersion: string = import.meta.env.VITE_ADS_VERSION || "v1";

export const navItems: INavItem[] = [
  {
    sectionLabel: "nav.dashboard",
    namePath: "nav.home",
    path: paths.app.home,
    icon: faHouseChimney,
  },
  ...(currentVersion === "v2"
    ? [
        {
          sectionLabel: "nav.services",
          namePath: "description.page",
          path: paths.description.index,
          icon: faMagicWandSparkles,
        },
      ]
    : []),
  ...(currentVersion === "v1"
    ? [
        {
          sectionLabel: "nav.services",
          namePath: "product.product_editor",
          path: paths.product.index,
          icon: faFilePen,
        },
      ]
    : []),
  {
    namePath: "ads.ads_writer",
    path: paths.ads.index,
    icon: faDrawSquare,
  },
  {
    namePath: "blog.blog_writer",
    path: paths.blog.index,
    icon: faFileLines,
  },
  {
    namePath: "background-remover.background_remover",
    path: paths["background-remover"].index,
    icon: faImage,
  },
  {
    namePath: "background-generator.background_generator",
    path: paths["background-generator"].index,
    icon: faWandMagicSparkles,
  },
  {
    namePath: "nav.photo_enhancer",
    path: paths["photo-enhancer"].index,
    customIcon: "photo-enhancer",
  },
  {
    namePath: "watermark-remover.watermark_remover",
    path: paths["watermark-remover"].index,
    icon: faDroplet,
  },
    {
    namePath: "nav.create_your_logo",
    path: "https://www.logome.ai/?utm_source=smartli",
    openInNewTab: true,
    icon: faPaintbrushPencil,
    newFlag: true,
  },
  ...(currentVersion === "v2"
    ? [
        {
          sectionLabel: "nav.other_features",
          namePath: "AI Content Humanizer",
          path: paths.content.index,
          icon: faPencil,
        },
        {
            namePath: "ai-models-photoshoot.ai_models_photoshoot",
            path: paths["ai-models-photoshoot"].index,
            icon: faCamera,
        },
      ]
    : []),
  {
    namePath: "settings.title",
    path: DISABLE_PAYMENTS ? paths.settings.account : paths.settings.plans,
    icon: faCog,
  },
  {
    namePath: "nav.notifications",
    path: "/notifications",
    icon: faBell,
    onClick: () => triggerShowNotifications(),
    getCountQuery: useGetUnreadNotifications,
  },
  {
    namePath: "nav.connect-store",
    path: "/connect-store",
    icon: faStore,
    onClick: () => triggerShowConnectStoreModal(),
  },
  {
    namePath: "nav.help_center",
    path: "https://www.notion.so/Smartli-1d80c13273a280c3901fd4fc79ccd0d3",
    openInNewTab: true,
    icon: faSquareInfo,
  },
];
